<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col xl="5" lg="5" md="5" sm="12" cols="12">
          <v-card
            elevation="6"
            :height="$vuetify.breakpoint.smAndDown ? 'auto' : '600'"
          >
            <v-card-title>
              <span>Total Values ({{ count }}) </span>
              <v-spacer></v-spacer>
              <vs-button
                class="mx-2 text-caption"
                color="#6c5dd4"
                @click="createformdialog = true"
                >+ Add Value</vs-button
              >
            </v-card-title>
            <v-progress-linear
              v-if="isLoading"
              indeterminate
              color="primary"
            ></v-progress-linear>
            <v-simple-table fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Sr No</th>
                    <th class="text-left">Name</th>
                    <th class="text-right">Action</th>
                  </tr>
                </thead>
                <tbody v-if="values.length != 0">
                  <tr v-for="(value, i) in values" :key="`value${i}`">
                    <td style="min-width: 85px">
                      &nbsp;
                      {{ i + 1 }}
                    </td>
                    <td>{{ value.name }}</td>
                    <td class="text-right">
                      <v-btn
                        class="mx-2"
                        fab
                        x-small
                        elevation="0"
                        color="#6c5dd4"
                        dark
                        @click="getValue(value.id)"
                      >
                        <v-icon size="15"> mdi-pencil </v-icon>
                      </v-btn>
                      <v-btn
                        class="mx-2"
                        fab
                        x-small
                        elevation="0"
                        :color="SelectRow != i ? '#6c5dd4' : 'success'"
                        dark
                        @click="getValueListData(value.id, i)"
                      >
                        <v-icon v-if="SelectRow != i" size="15">
                          mdi-plus
                        </v-icon>
                        <v-icon v-else size="15"> mdi-close </v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="6" class="text-center">No data found</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
        <v-col xl="7" lg="7" md="7" sm="12" cols="12">
          <v-card elevation="6">
            <v-card-title> Value List of : {{ ValueName || "" }} </v-card-title>
            <v-simple-table
              fixed-header
              :height="$vuetify.breakpoint.smAndDown ? 'auto' : '535'"
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" v-if="!$vuetify.breakpoint.smAndDown">Sr No</th>
                    <th class="text-left">Description</th>
                    <th class="text-left">Code</th>
                    <th class="text-right">Action</th>
                  </tr>
                </thead>
                <tbody v-if="value_id != null">
                  <tr
                    v-for="(valueList, i) in valueLists"
                    :key="`valueList${i}`"
                  >
                    <td v-if="!$vuetify.breakpoint.smAndDown">{{ i + 1 }}</td>
                    <td>
                      <v-col class="px-0" cols="12">
                        <v-text-field
                          v-model="valueList.description"
                          outlined
                          dense
                          label="Description"
                          :input="
                            (valueList.description =
                              valueList.description ? valueList.description.toUpperCase() : '')
                          "
                          hide-details="auto"
                          :error-messages="
                            valueList.description == ''
                              ? 'this description field is required'
                              : ''
                          "
                        ></v-text-field>
                      </v-col>
                    </td>
                    <td>
                      <v-col class="px-0" cols="12">
                        <v-text-field
                          :error-messages="
                            valueList.code == ''
                              ? 'this code field is required'
                              : ''
                          "
                          v-model="valueList.code"
                          :input="
                            (valueList.code = valueList.code ? valueList.code.toUpperCase() : '')
                          "
                          outlined
                          dense
                          label="Code"
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                    </td>

                    <td class="text-right">
                      <div class="text-center">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="#6c5dd4"
                              icon
                              @click="delete_data(valueList.id)"
                            >
                              <v-icon>mdi-delete-outline</v-icon>
                            </v-btn>
                          </template>
                          <span>Delete</span>
                        </v-tooltip>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="value_id != null">
                    <td colspan="4">
                      <v-btn
                        outlined
                        block
                        color="#6c5dd4"
                        @click="addEmptyValueList()"
                      >
                        Add New Row
                      </v-btn>
                    </td>
                  </tr>
                  <tr v-if="value_id != null">
                    <td colspan="2"></td>
                    <td colspan="2">
                      <vs-button
                        block
                        color="#6c5dd4"
                        :loading="isSaving"
                        :disabled="isSaving"
                        @click="ValueListSave()"
                      >
                        Save
                      </vs-button>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="4" class="text-center">
                      Please Select any value from left
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
      <!-- create form -->
      <vs-dialog v-model="createformdialog" :loading="isLoading">
        <v-col cols="12" class="px-1">
          <label for="" class="text-caption">Name * </label>
          <vs-input
            primary
            v-model="Createform.name"
            @input="Createform.name = Createform.name ? Createform.name.toUpperCase() : ''"
            placeholder="Enter value name *"
            icon-after
            block
          >
            <template #icon>
              <i class="mdi mdi-account"></i>
            </template>

            <template #message-danger>
              {{ errors && errors.name ? errors.name : "" }}
            </template>
          </vs-input>
        </v-col>
        <v-col cols="12">
          <vs-button
            class="float-end"
            :loading="isLoading"
            color="#6c5dd4"
            dark
            @click="save"
          >
            Save Value
          </vs-button>
        </v-col>
      </vs-dialog>
      <!-- Edit form -->
      <vs-dialog v-model="editformdialog" :loading="isLoading">
        <v-col cols="12" class="px-1">
          <label for="" class="text-caption">Name * </label>
          <vs-input
            primary
            v-model="Editform.name"
            @input="Editform.name = Editform.name ? Editform.name.toUpperCase() : ''"
            placeholder="Enter value name *"
            icon-after
            block
          >
            <template #icon>
              <i class="mdi mdi-account"></i>
            </template>

            <template #message-danger>
              {{ errors && errors.name ? errors.name : "" }}
            </template>
          </vs-input>
        </v-col>
        <v-col cols="12">
          <vs-button
            class="float-end"
            :loading="isLoading"
            color="#6c5dd4"
            dark
            @click="update(Editform.id)"
          >
            Update Value
          </vs-button>
        </v-col>
      </vs-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "valuesPage",
  data() {
    return {
      count: 0,
      isLoading: false,
      isSaving: false,
      createformdialog: false,
      editformdialog: false,
      Createform: {},
      Editform: {},
      values: [],
      valueLists: [],
      value_id: null,
      ValueName: "",
      SelectRow: null,
    };
  },
  computed: {
    valuelist() {
      return this.valueLists ? this.valueLists : [];
    },
    valueID() {
      return this.value_id ? this.value_id : null;
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let values = await axios.get(`/values`);
      this.values = values.data.data;
      this.count = values.data.count;
      this.isLoading = false;
    },
    //create value
    async save() {
      try {
        this.isLoading = true;
        await axios.post("/values", this.Createform);
        this.isLoading = false;
        this.createformdialog = false;
        this.Createform = {};
        this.getData();
      } catch (e) {
        this.isLoading = false;
      }
    },
    // get value id
    async getValue(ValueId) {
      this.Editform = {};
      this.isLoading = true;
      let form = await axios.get(`/values/${ValueId}`);
      this.Editform = form.data.data;
      this.editformdialog = true;
      this.isLoading = false;
    },
    //edit value
    async update(ValueId) {
      try {
        this.isLoading = true;
        await axios.patch(`/values/${ValueId}`, this.Editform);
        this.isLoading = false;
        this.editformdialog = false;
        this.getData();
      } catch (e) {
        this.isLoading = false;
      }
    },
    //get value list
    async getValueListData(valueId, index) {
      this.value_id = valueId;
      this.SelectRow = index;
      console.log(this.value_id);
      let valueLists = await axios.get(`/values/${valueId}/value_lists`);
      this.valueLists = valueLists.data.data;
      this.ValueName = this.values.find((value) => value.id === valueId).name;
    },
    addEmptyValueList() {
      this.valueLists.push({
        value_id: this.value_id,
        description: "",
        code: "",
        is_active: 1,
      });
    },
    // save value list
    async ValueListSave() {
      if (this.valueLists.length > 0) {
        this.isSaving = true;
        let payload = {
          datas: this.valueLists,
        };

        let response = await axios.post(
          `/values/${this.value_id}/value_lists_multiple`,
          payload
        );
        this.valueLists = response.data.data;
        this.isSaving = false;
      }
    },
    // delete value list
    async delete_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.delete(`value_lists/${id}`);
          this.isLoading = false;
          this.getValueListData();
        } catch (e) {
          console.log(e);
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
